export const BULLETS_MIN_SIZE = 25;
export const BULLETS_MAX_SIZE = 400;
export const BULLETS_SIZE_STEP = 1;
export const BULLETS_SIZE_MAX_LENGTH = 3;

export const MIN_START_NUMBER = 1;
export const MAX_START_NUMBER = 32767;
export const START_NUMBER_STEP = 1;
export const START_NUMBER_MAX_LENGTH = 5;

/**
 * 打开编辑面板的来源
 */
export const enum SOURCE_ID {
    toolBarBullet = 'toolBarBullet',
    toolBarNumber = 'toolBarNumber',
    sideBarBullet = 'sideBarBullet',
    sideBarNumber = 'sideBarNumber',
}
